import React from 'react';
import { FadeIn } from './ui/FadeIn';
export const Problem = () => {
  return <section className="py-20 md:py-28 bg-dark-card relative border-y border-white/5" data-id="element-116">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-neon/5 rounded-full blur-[120px] pointer-events-none" data-id="element-117" />

      <div className="container mx-auto px-4 max-w-4xl relative z-10" data-id="element-118">
        <FadeIn data-id="element-119">
          <div className="text-center mb-10" data-id="element-120">
            <span className="text-[#ADFF2F] font-bold tracking-[0.2em] uppercase text-sm mb-4 block" data-id="element-121">
              La solución
            </span>
            <h2 className="text-3xl md:text-5xl lg:text-6xl font-bold text-white leading-tight" data-id="element-122">
              El Plan de Emergencia Financiera de{' '}
              <span className="text-neon" data-id="element-123">48 Horas</span>
            </h2>
          </div>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-124">
          <div className="bg-[#111111] border border-white/10 rounded-2xl p-8 md:p-12" data-id="element-125">
            <p className="text-lg md:text-xl text-gray-300 leading-relaxed font-sans text-center m-0" data-id="element-126">
              Un sistema práctico y directo que te muestra exactamente qué hacer
              en las próximas{' '}
              <span className="text-white font-semibold" data-id="element-127">48 horas</span> para
              activar una fuente de ingresos adicionales usando las habilidades
              y recursos que ya tienes.
              <br data-id="element-128" />
              <br data-id="element-129" />
              <span className="text-[#ADFF2F] font-semibold" data-id="element-130">
                Sin promesas vacías. Sin teoría innecesaria.
              </span>{' '}
              Solo pasos concretos que puedes ejecutar hoy.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
};